import { useEffect, useState } from "react";
import axios from "axios";
import {
  BarChart3,
  GraduationCap,
  Presentation,
  Loader2,
} from "lucide-react";
import { base_url } from "../../config";
import Workshops from "./Workshops";
import Tutorials from "./Tutorials";
import Stats from "./Stats";

const TABS = [
  { id: "stats",     label: "Stats",     icon: <BarChart3 className="h-4 w-4" /> },
  { id: "workshops", label: "Workshops", icon: <Presentation className="h-4 w-4" /> },
  { id: "tutorials", label: "Tutorials", icon: <GraduationCap className="h-4 w-4" /> },
];

export default function WorkshopsTutorials() {
  const [ws, setWs] = useState([]);
  const [tut, setTut] = useState([]);
  const [wstutDays, setWsTutDays] = useState([]);
  const [loadingWs, setLoadingWs] = useState(true);
  const [loadingTut, setLoadingTut] = useState(true);
  const [loadingChartData, setLoadingChartData] = useState(true);
  const [tab, setTab] = useState("stats");

  useEffect(() => {
    setLoadingTut(true);
    setLoadingWs(true);
    setLoadingChartData(true);
    axios
      .get(`${base_url}/api/admin/get_ws`)
      .then((response) => setWs(response.data))
      .catch((error) => console.error("Error fetching workshops:", error))
      .finally(() => setLoadingWs(false));
    axios
      .get(`${base_url}/api/admin/get_tut`)
      .then((response) => setTut(response.data))
      .catch((error) => console.error("Error fetching tutorials:", error))
      .finally(() => setLoadingTut(false));
    axios
      .get(`${base_url}/api/admin/get_ws_tut_days`)
      .then((response) => setWsTutDays({ ...response.data }))
      .catch((error) => console.error("Error fetching data:", error))
      .finally(() => setLoadingChartData(false));
  }, []);

  const loading = loadingWs || loadingTut || loadingChartData;

  return (
    <div className="dark min-h-screen bg-slate-950 text-slate-100">
      <div className="mx-auto max-w-[1500px] px-4 py-5 space-y-4">
        <header className="flex items-baseline justify-between flex-wrap gap-2">
          <h1 className="text-lg font-bold flex items-center gap-2">
            <BarChart3 className="h-5 w-5 text-blue-400" />
            Workshops &amp; Tutorials
          </h1>
          {!loading && (
            <span className="text-xs text-slate-400">
              {ws.length} workshops · {tut.length} tutorials
            </span>
          )}
        </header>

        <div className="inline-flex p-1 rounded-xl border border-slate-700/40 bg-slate-800/40 gap-1">
          {TABS.map((t) => {
            const active = tab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                  active
                    ? "bg-blue-500/20 text-blue-200 border border-blue-500/40"
                    : "text-slate-300 border border-transparent hover:bg-slate-700/40 hover:text-slate-100"
                }`}
              >
                {t.icon}
                {t.label}
              </button>
            );
          })}
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-24">
            <Loader2 className="h-8 w-8 text-blue-400 animate-spin" />
          </div>
        ) : (
          <div>
            {tab === "stats" && <Stats ws={ws} tut={tut} wstutDays={wstutDays} />}
            {tab === "workshops" && <Workshops ws={ws} />}
            {tab === "tutorials" && <Tutorials tut={tut} />}
          </div>
        )}
      </div>
    </div>
  );
}
